/* @flow */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {
  Form,
  Grid,
  Input,
  Button,
  Divider,
  Header,
  Icon,
} from 'semantic-ui-react';
import ResourceCard from 'shared/components/ResourceCard';
import DocumentOrderButtons from './DocumentOrderButtons';
import GalleryContent from './GalleryContent';
import type { MySpaceDocument } from '../types';

type Props = {
  doc: MySpaceDocument,
  docs: List<MySpaceDocument>,
  onUpdate: (doc: MySpaceDocument) => void,
  onOrderChanged: (doc: MySpaceDocument, order: number) => void,
  onDelete: (id: string) => void,
};

type State = {};

const styles = {
  action: {
    marginLeft: '1.5em',
    display: 'flex',
  },
};

const getDocumentItem = doc => {
  switch (doc.type) {
    case 'file':
      return 'file outline';
    case 'youtube':
      return 'youtube';
    case 'gallery':
      return 'photo';
    default:
      return null;
  }
};

class DocumentItem extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    if (this.props.doc.isNew) {
      let element = ReactDOM.findDOMNode(this.item);

      // TODO: timeout to remove if children does not mutate their state (or does not have one) when they mount
      // Here timeout is set because some children use ProgressiveImage Component
      setTimeout(() => {
        element.scrollIntoView({ block: 'end' });
      }, 200);
    }
  }

  renderDocumentContent(doc) {
    const { onUpdate } = this.props;

    switch (doc.type) {
      case 'gallery':
        return <GalleryContent doc={doc} onUpdate={onUpdate} />;
      default:
        return null;
    }
  }

  render() {
    const { doc, docs, onUpdate, onOrderChanged, onDelete } = this.props;

    const nameChanged = event =>
      onUpdate({
        ...doc,
        name: event.target.value,
      });

    const messageChanged = event =>
      onUpdate({
        ...doc,
        message: event.target.value,
      });

    const orderChanged = order => onOrderChanged(doc, order);

    const canOrderUp = doc.order > 0;
    const canOrderDown = doc.order < docs.size - 1;
    const orderUp = () => orderChanged(doc.order - 1);
    const orderDown = () => orderChanged(doc.order + 1);

    const thumbnailSelected = resource =>
      onUpdate({
        ...doc,
        thumbnail: resource,
        thumbnailId: resource.id,
      });

    const thumbnailDeleted = () =>
      onUpdate({
        ...doc,
        thumbnail: undefined,
        thumbnailId: undefined,
      });

    const remove = () => onDelete(doc);

    return (
      <div
        className="ui item"
        ref={ref => {
          this.item = ref;
        }}
      >
        <Grid style={{ width: '100%' }}>
          <Grid.Row>
            <Grid.Column width={4}>
              <Header as="h4">Vignette</Header>
              <ResourceCard
                resource={doc.thumbnail}
                resourceType="image"
                onSelected={thumbnailSelected}
                onDeleted={thumbnailDeleted}
              />
            </Grid.Column>
            <Grid.Column width={1} />
            <Grid.Column width={9} verticalAlign="middle" textAlign="center">
              <Header as="h2">
                <Icon name={getDocumentItem(doc)} />
              </Header>
              <Form>
                <Form.Field>
                  <label style={{ textAlign: 'left' }}>Date</label>
                  <Input type="text" readOnly fluid defaultValue={doc.date} />
                </Form.Field>
                <Form.Field>
                  <label style={{ textAlign: 'left' }}>Nom</label>
                  <Input
                    type="text"
                    fluid
                    value={doc.name}
                    onChange={nameChanged}
                  />
                </Form.Field>
                <Form.Field>
                  <label style={{ textAlign: 'left' }}>Message</label>
                  <textarea
                    value={doc.message || ''}
                    onChange={messageChanged}
                  />
                </Form.Field>
              </Form>
              <Divider hidden />
              <Button
                icon="close"
                color="red"
                size="small"
                content="Supprimer"
                labelPosition="right"
                onClick={remove}
              />
            </Grid.Column>
            <Grid.Column width={2} verticalAlign="middle">
              <div className="ui small action" style={styles.action}>
                <DocumentOrderButtons
                  canOrderUp={canOrderUp}
                  canOrderDown={canOrderDown}
                  onOrderUp={orderUp}
                  onOrderDown={orderDown}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
          <Divider />
          <Grid.Row>{this.renderDocumentContent(doc)}</Grid.Row>
          <Divider hidden />
        </Grid>
      </div>
    );
  }
}

export default DocumentItem;



// WEBPACK FOOTER //
// ./src/modules/my-space/components/DocumentItem.js